import React, {useEffect, useContext} from 'react';
import BreadcrumbContext from "../contexts/breadcrumb/BreadcrumbContext";


export default function useBreadcrumb(items, deps = []) {
    const breadcrumbContext = useContext(BreadcrumbContext);

    useEffect(() => {
        breadcrumbContext.setItems(items);

        return () => breadcrumbContext.setItems([]);
    }, deps);
}
